import Vue from 'vue'
import Router from 'vue-router'

import config from '@/config'
import VueRouter from 'vue-router'
const title = config.title
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'homePage',
      component: resolve => require(['@/view/homePage/index'], resolve),
      children:[
        // 首页
        {
          path:'/home',
          name:'home',
          component: resolve => require(['@/view/homePage/content/home'], resolve),
        },

        // 核心业务
        {
          path:'/mainServiceInfo',
          name:'mainServiceInfo',
          component: resolve => require(['@/view/homePage/content/mainService/index'], resolve),
          children:[
            {
              path:'/mainServiceInfo_one',
              name:'mainServiceInfo_one',
              component: resolve => require(['@/view/homePage/content/mainService/index'], resolve),
            },
            {
              path:'/mainServiceInfo_two',
              name:'mainServiceInfo_two',
              component: resolve => require(['@/view/homePage/content/mainService/index'], resolve),
            },
            {
              path:'/mainServiceInfo_three',
              name:'mainServiceInfo_three',
              component: resolve => require(['@/view/homePage/content/mainService/index'], resolve),
            },
            {
              path:'/mainServiceInfo_four',
              name:'mainServiceInfo_four',
              component: resolve => require(['@/view/homePage/content/mainService/index'], resolve),
            },
            {
              path:'/mainServiceInfo_five',
              name:'mainServiceInfo_five',
              component: resolve => require(['@/view/homePage/content/mainService/index'], resolve),
            },
            {
              path:'/mainServiceInfo_six',
              name:'mainServiceInfo_six',
              component: resolve => require(['@/view/homePage/content/mainService/index'], resolve),
            },
          ]
        },

        // 服务优势
        {
          path:'/serviceAdvantage',
          name:'serviceAdvantage',
          component: resolve => require(['@/view/homePage/content/components/serviceAdvantage'], resolve),
        },
        // 物流追踪
        {
          path:'/tracking',
          name:'tracking',
          component: resolve => require(['@/view/homePage/content/tracking/index'], resolve),
        },
        // 新闻资讯
        {
          path:'/news',
          name:'news',
          component: resolve => require(['@/view/homePage/content/news/index'], resolve),
          // children:[
          //   {
          //     path:'/news_one',
          //     name:'news_one',
          //     component: resolve => require(['@/view/homePage/content/news/index'], resolve),
          //   },
          //   {
          //     path:'/news_two',
          //     name:'news_two',
          //     component: resolve => require(['@/view/homePage/content/news/index'], resolve),
          //   },
          // ]
        },
        // 新闻资讯 详情
        {
          path:'/newsDetail',
          name:'newsDetail',
          component: resolve => require(['@/view/homePage/content/news/detail'], resolve),
        },
        // 关于我们
        {
          path:'/aboutUs',
          name:'aboutUs',
          component: resolve => require(['@/view/homePage/content/aboutUs/index'], resolve),
          children:[
            {
              path:'/aboutUs_one',
              name:'aboutUs_one',
              component: resolve => require(['@/view/homePage/content/aboutUs/index'], resolve),
            },
            {
              path:'/aboutUs_two',
              name:'aboutUs_two',
              component: resolve => require(['@/view/homePage/content/aboutUs/index'], resolve),
            },
            {
              path:'/aboutUs_three',
              name:'aboutUs_three',
              component: resolve => require(['@/view/homePage/content/aboutUs/index'], resolve),
            },
            {
              path:'/aboutUs_four',
              name:'aboutUs_four',
              component: resolve => require(['@/view/homePage/content/aboutUs/index'], resolve),
            },
          ]
        },
      ]
    }
  ],
  scrollBehavior(to,from,savePosition) {
    return {x:0,y:0}
  }
})

/* router版本问题会抛出错误，已下解决路由调整报错问题 */
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location){
  return originalReplace.call(this,location).catch(err => err);
}


// WEBPACK FOOTER //
// ./src/router/index.js